import { render, staticRenderFns } from "./OrderTrStatus.vue?vue&type=template&id=e1bc939a&"
import script from "./OrderTrStatus.vue?vue&type=script&lang=js&"
export * from "./OrderTrStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports